import {  useEffect, useMemo, useState } from 'react';
import {
  MRT_EditActionButtons,
  MaterialReactTable,
  // createRow,
  type MRT_ColumnDef,
  type MRT_Row,
  type MRT_TableOptions,
  useMaterialReactTable,
} from 'material-react-table';
import {
  Box,
  Button,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Stack,
  Tooltip,
} from '@mui/material';
import {
  QueryClient,
  QueryClientProvider,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { AxiosInstance } from '../../api/apiInstance';
import { useSelector } from 'react-redux';
import { IUser } from '../../interface/IUser';
import { useParams } from 'react-router-dom';
import RefreshIcon from '@mui/icons-material/Refresh';
import { IproductLocation} from '../../interface/IProducts';
import { muiTableHeadCellPropsHelper } from '../../helper/helper';

// type  Props = {  
//   setSingleOrderData: ( SingleOrderData: IOrderHeader)  => void;
//   singleOrderData: IOrderHeader  ;
// }
function ProductHierarchy  ()  {      
  const { productId } = useParams();
  const userinfo: IUser = useSelector((state: any) => state.user)   
  const [validationErrors, setValidationErrors] = useState<
    Record<string, string | undefined>
  >({});
  const hiddenColumns = {   
    id: false,    
  } 

  
  const columns = useMemo<MRT_ColumnDef<IproductLocation>[]>(
    () => [
      {
        accessorKey: 'id',
        header: 'id',
        enableEditing: false,
       
      },  
      {
        accessorKey: 'PARTNAME',
        header: 'PARTNAME',
        enableEditing: false,
       
      }, 
      {
        accessorKey: 'BARCODE',
        header: 'BARCODE',
        enableEditing: false,
       
      },   
          
     
    
      
      
    ],
    [validationErrors],
  );

 

  const {
    data: fetchedData = [],
    isError: isLoadingError,
    isFetching: isFetching,
    isLoading: isLoading,
    refetch,
  } = useGetProductHierarchy();
  
  //READ hook (get Orders from api)
    function useGetProductHierarchy() {
      return useQuery<IproductLocation[]>({
        queryKey: ['priorityProductsHierarchy'],
        queryFn: async () => {
          //send api request here
          let tmpUrl = 'priorityProducts/findChildByParent/'+ productId;          
          return await AxiosInstance.get (
            tmpUrl,    
          
  
          ).then((res) => {
            return res.data as IproductLocation[];              
          });
        },
        refetchOnWindowFocus: 'always',
      });
    }


  const table = useMaterialReactTable({
    columns,
    data: fetchedData,
    createDisplayMode: 'modal', //default ('row', and 'custom' are also available)
    editDisplayMode: 'modal', //default ('row', 'cell', 'table', and 'custom' are also available)
    enableEditing: false,
    enableDensityToggle:false,  
    initialState: { columnVisibility: hiddenColumns ,density: 'compact'},
    enableHiding: false,
    enableColumnActions: false,
    enablePagination: false,
  
    enableSorting:false,
    enableBottomToolbar:false,
    enableColumnFilters:false,
    enableColumnOrdering:false,
    enableColumnFilterModes:false,  
    enableFilterMatchHighlighting:false,
    enableGlobalFilter:false,
    enableFullScreenToggle: false,
    getRowId: (row) => row.id,      
    // muiTableContainerProps: {
    //   sx: {
    //     minHeight: '300px',
    //   },
    // },
    muiTableHeadCellProps: {
      //no useTheme hook needed, just use the `sx` prop with the theme callback
      sx: (theme) => ({
        muiTableHeadCellPropsHelper
      }),
    },
    renderCreateRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Add New Hierarchy</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    //optionally customize modal content
    renderEditRowDialogContent: ({ table, row, internalEditComponents }) => (
      <>
        <DialogTitle variant="h3">Edit Box</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: '1.5rem' }}
        >
          {internalEditComponents} {/* or render custom edit components here */}
        </DialogContent>
        <DialogActions>
          <MRT_EditActionButtons variant="text" table={table} row={row} />
        </DialogActions>
      </>
    ),
    muiTableBodyCellProps: ({ column }) => ({
      //conditionally style pinned columns
      sx: {
        fontWeight: '500' ,
        fontSize: '15px',
      },
    }),
    onCreatingRowCancel: () => setValidationErrors({}),    
    onEditingRowCancel: () => setValidationErrors({}),   
    
    renderTopToolbarCustomActions: ({ table }) => (
      // <></>
      <div>      
        <Tooltip arrow title="Refresh Data">
          <IconButton size="large" onClick={() => refetch()}>
            <RefreshIcon />
          </IconButton>
        </Tooltip>      
      </div>
    ),
    state: {
      isLoading: isLoading,
      //isSaving: isCreatingTask || isUpdatingTask || isDeletingTask,
      showAlertBanner: isLoadingError,
      showProgressBars: isFetching,
    },
   
  });

  return     <MaterialReactTable table={table}  />;
};


function validateProductLocation(productLocation: any) {

}

const queryClient = new QueryClient();

const ExampleWithProviders = () => (
  //Put this with your other react-query providers near root of your app
  <QueryClientProvider client={queryClient}>
    <Stack>
    <h2>Product Hierarchy</h2>
    <ProductHierarchy />
    </Stack>
  </QueryClientProvider>
 
);

export default ExampleWithProviders;





